module.exports = "<button>Refresh</button>";